<script>
import {mapActions} from "pinia";
import {profileStore} from "@/store/profileStore";
import i18n from "@/i18n";
import BaseTab from "@/components/BaseTab.vue";
import ProfilePoliticianInfoItem from "@/views/profile/ProfilePoliticianInfoItem.vue";

export default {
  name: "ProfilePoliticianInfo",
  props: {
    profileId: {
      type: Number
    }
  },
  components: {
    BaseTab,
    ProfilePoliticianInfoItem
  },
  data() {
    return {
      activeTab: {},
      expandedState: true,
      tabs: [
        {
          label: i18n.global.t('profile.election.candidacies'),
          code: 'CANDIDATE',
        }, {
          label: i18n.global.t('profile.election.electedOfficial'),
          code: 'ELECTED',
        },
      ],
      candidacies: [],
      electedOfficial: []
    }
  },
  methods: {
    ...mapActions(profileStore, [
      'getProfilePoliticianCandidates',
      'getProfilePoliticianAssignments'
    ]),
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    toggleExpandedState() {
      this.expandedState = !this.expandedState;
    }
  },
  beforeMount() {
    if (this.profileId) {
      this.getProfilePoliticianCandidates(this.profileId).then((resp)=> {
        this.candidacies = resp.data;
      });

      this.getProfilePoliticianAssignments(this.profileId).then((resp)=> {
        this.electedOfficial = resp.data;
      });
    }
  },
  mounted() {
    this.activeTab = this.tabs[0];
  },
}
</script>

<template>
<div class="profile-politician-info-wrap">
  <div class="profile-politician-info">
    <div class="profile-politician-tabs">
      <base-tab v-for="tab in tabs"
                :key="tab.code"
                :label="tab.label"
                :active="tab.code === activeTab.code"
                @click="setActiveTab(tab)"
      ></base-tab>
      <div class="profile-politician-info-controls">
        <span class="profile-politician-info-controls__text">{{$t('profile.election.period')}}</span>
        <font-awesome-icon v-if="expandedState"
                           :icon="['fas', 'chevron-up']"
                           class="profile-politician-info-controls__icon"
                           @click="toggleExpandedState()"
        />
        <font-awesome-icon v-else
                           :icon="['fas', 'chevron-down']"
                           class="profile-politician-info-controls__icon"
                           @click="toggleExpandedState()"
        />
      </div>
    </div>
    <div v-show="expandedState" class="profile-politician-content">
      <div v-show="activeTab.code === 'CANDIDATE'" class="profile-politician-list">
        <profile-politician-info-item v-for="item in candidacies"
                                      :key="item.election.id"
                                      :item-data="item"
        />
      </div>
      <div v-show="activeTab.code === 'ELECTED'" class="profile-politician-list">
        <profile-politician-info-item v-for="item in electedOfficial"
                                      :key="item.id"
                                      :item-data="item"
        />
      </div>
      <div class="integrated-data-info">
        <div class="integrated-data-info__icon"></div>
        <div class="integrated-data-info__text">
          {{$t('profile.election.integratedDataInfo')}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<style lang="scss">
.profile-politician-info-wrap {
  width: 600px;
  margin-bottom: 15px;
}
.profile-politician-info {
  background: #fff;

  .profile-politician-tabs {
    display: flex;
    height: 36px;
    border-bottom: 1px solid #ddd;
    box-shadow: 0 1px 1px #ddd;
    white-space: nowrap;
    background: #fff;

    .base-tab {
      width: auto;
      padding: 0 15px;
    }
  }

  .profile-politician-info-controls {
    display: flex;
    margin-left: auto;
    align-items: center;
    &__text {
      margin-right: 50px;
    }
    &__icon {
      padding: 10px 15px;
      color: #7835a6;
      cursor: pointer;
    }
  }

  .profile-politician-content {
    display: flex;
    flex-direction: column;
    .profile-politician-list {
      padding: 8px 0 18px;
      .politician-item {
        &:last-child {
          &:after {
            content: none;
          }
        }
      }
    }
    .integrated-data-info {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 12px 18px;
      padding: 12px 0;
      border-radius: 8px;
      box-shadow: 0 1px 4px 0 rgba(79, 79, 79, .21);
      background-color: #fff;

      &__icon {
        width: 18px;
        min-width: 18px;
        height: 18px;
        margin-right: 15px;
        background: url("~@/assets/img/profile/orange-info-icon.svg") no-repeat center;
      }
      &__text {
        max-width: 430px;
        font-size: 13px;
        color: #4f4f4f;
        line-height: 1.4;
        text-align: center;
      }
    }
  }

}
</style>